const initCardListTextCta = () => {
    initCarousel("[data-card-list-slider]", cellAlign.center, false, false, false, false, true, 1024, true);
};
